import { BaseDto } from './base.dto';

export class DeliverAreaDto extends BaseDto {
  id: number;
  merchantId: number;
  area: string;
  averageDeliveryTime: number;
  deliveryFee: number;
}